@if (user) {
  @if (cognitoUser$ | async; as cognitoAuthenticatedUser) {
    @if (showBackButton) {
      <div class="inner-navigation">
        <div class="back" (click)="navigateBack()">
          <p class="text-button-small">{{ 'account.back-button-text' | translate }}</p>
        </div>
      </div>
    }
    <div class="page-name">
      <h3>{{ 'account.page-name' | translate }}</h3>
    </div>
    <div class="block">
      <div class="block-title">
        <p class="tag-12">
          {{ 'account.personal-info-title' | translate }}
        </p>
      </div>
      <div class="row">
        <div class="title">
          <p class="subtitle-14">{{ 'account.picture-label' | translate }}</p>
        </div>
        <div class="image-input-container">
          <input
            class="image-input"
            type="file"
            [accept]="'image/*'"
            (change)="onFileChange($event)"
            #fileInput
            [multiple]="false"/>
            <div class="image-container" (click)="fileInput.click()">
              @if (avatar) {
                <img class="image" [src]="avatar" alt="avatar">
              }
              @if (!avatar) {
                <img class="image" src="assets/parent_icon_placeholder.png" alt="avatar">
              }
              @if (!avatar) {
                <div class="plus-overlay">
                  <img class="no-image" src="assets/add_round_fill.svg" alt="no-image"/>
                </div>
              }
              @if (avatar) {
                <div class="edit-overlay" (click)="$event.stopPropagation(); fileInput.click()"><img src="assets/edit_pencil_fill.svg" alt="edit"></div>
              }
            </div>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="subtitle-14">{{ 'account.first-name-title' | translate }}</p>
          </div>
          <div class="input">
            <input
              class="input"
              type="text"
              [placeholder]="'account.first-name-placeholder' | translate"
              [(ngModel)]="user.firstName"/>
            </div>
          </div>
          <div class="row">
            <div class="title">
              <p class="subtitle-14">{{ 'account.last-name-title' | translate }}</p>
            </div>
            <div class="input">
              <input
                class="input"
                type="text"
                [placeholder]="'account.last-name-placeholder' | translate"
                [(ngModel)]="user.lastName"/>
              </div>
            </div>
            <div class="row">
              <div class="title">
                <p class="subtitle-14">{{ 'account.date-of-birth' | translate }}</p>
              </div>
              <div class="date-select">
                <div class="inline-select">
                  <mat-select class="input" [(ngModel)]="selectedYear" (selectionChange)="onYearChange()"
                    [placeholder]="'account.year-placeholder' | translate">
                    @for (year of yearsList; track year) {
                      <mat-option [value]="year.value">{{ year.label }}</mat-option>
                    }
                  </mat-select>
                </div>
                <div class="inline-select">
                  <mat-select class="input" [(ngModel)]="selectedMonth" (selectionChange)="onMonthChange()"
                    [placeholder]="'account.month-placeholder' | translate">
                    @for (month of monthsList; track month) {
                      <mat-option [value]="month.value">{{ month.label | translate }}</mat-option>
                    }
                  </mat-select>
                </div>
                <div class="inline-select">
                  <mat-select class="input" [(ngModel)]="selectedDay" (selectionChange)="onDayChange()"
                    [placeholder]="'account.day-placeholder' | translate">
                    @for (day of daysList; track day) {
                      <mat-option [value]="day.value">{{ day.label }}</mat-option>
                    }
                  </mat-select>
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="block-title">
              <p class="tag-12">
                {{ 'account.contact-info-title' | translate }}
              </p>
            </div>
            <div class="row">
              <div class="title">
                <p class="subtitle-14">{{ 'account.email-title' | translate }}</p>
              </div>
              <div class="input">
                <input
                  class="input"
                  type="text"
                  [placeholder]="'account.email-placeholder' | translate"
                  [(ngModel)]="cognitoAuthenticatedUser.email"/>
                </div>
              </div>
              <div class="row">
                <div class="title">
                  <p class="subtitle-14">{{ 'account.phone-title' | translate }}</p>
                </div>
                <div class="input">
                  <input
                    class="input"
                    type="text"
                    [placeholder]="'account.phone-placeholder' | translate"
                    [(ngModel)]="user.phoneNumber"/>
                  </div>
                </div>
              </div>
              <div class="block">
                <div class="block-title">
                  <p class="tag-12">
                    {{ 'account.location-info-title' | translate }}
                  </p>
                </div>
                <div class="row">
                  <div class="title">
                    <p class="subtitle-14">{{ 'account.country-title' | translate }}</p>
                  </div>
                  <div class="input">
                    <!-- Read-only: the country identifies the policy, so only customer
                    service can change it. The stored value is an ISO code. -->
                    <input
                      class="input"
                      type="text"
                      disabled
                      [placeholder]="'account.country-placeholder' | translate"
                      [ngModel]="countryLabel"
                      [ngModelOptions]="{ standalone: true }"/>
                    </div>
                  </div>
                  <div class="row-wrapper">
                    <div class="row flex-2">
                      <div class="title">
                        <p class="subtitle-14">{{ 'account.street-title' | translate }}</p>
                      </div>
                      <div class="input">
                        <input
                          class="input"
                          type="text"
                          [placeholder]="'account.street-placeholder' | translate"
                          [(ngModel)]="user.street"/>
                        </div>
                      </div>
                      <div class="row flex-1">
                        <div class="title">
                          <p class="subtitle-14">{{ 'account.house-number-title' | translate }}</p>
                        </div>
                        <div class="input">
                          <input
                            class="input"
                            type="text"
                            [placeholder]="'account.house-number-placeholder' | translate"
                            [(ngModel)]="user.houseNumber"/>
                          </div>
                        </div>
                      </div>
                      <div class="row-wrapper">
                        <div class="row flex-1">
                          <div class="title">
                            <p class="subtitle-14">{{ 'account.zip-title' | translate }}</p>
                          </div>
                          <div class="input">
                            <input
                              class="input"
                              type="text"
                              [placeholder]="'account.zip-placeholder' | translate"
                              [(ngModel)]="user.zip"/>
                            </div>
                          </div>
                          <div class="row flex-2">
                            <div class="title">
                              <p class="subtitle-14">{{ 'account.city-title' | translate }}</p>
                            </div>
                            <div class="input">
                              <input
                                class="input"
                                type="text"
                                [placeholder]="'account.city-placeholder' | translate"
                                [(ngModel)]="user.city"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="block">
                          <div class="row">
                            <button class="button primary" [disabled]="!isFormChanged()" (click)="saveCognitoChangesPopup(cognitoAuthenticatedUser)">
                              {{ 'account.save-button' | translate }}
                            </button>
                          </div>
                        </div>
                      }
                    }
